
































































import { Component, Prop, Vue } from 'vue-property-decorator';

import { designStore } from '@/store/store';
import PxNumberInput from '@/views/components/input/formFields/PxNumberInput.vue';
import PxDropdown from '@/views/components/input/formFields/PxDropdown.vue';
import { findZr } from '@/modules/design/lib/calculations/calculationUtils';
import { AsphaltDesignMetric, IAsphaltDesignImperial } from '@/modules/design/interfaces/newAsphalt';
import { Route } from 'vue-router';
import { createAsphaltValidations } from '@/modules/design/lib/validations/asphalt';

@Component({
  components: {
    PxDropdown,
    PxNumberInput,
  },
})
export default class NewAsphaltDesignParameters extends Vue {
  @Prop() readonly pxDesignId!: string;

  @Prop() readonly page!: number;

  // scenario = designStore.currentAsphalt;

  get scenario(): IAsphaltDesignImperial | AsphaltDesignMetric {
    const n = designStore.currentAsphalt;
    console.log('refetching scenario, units:', n.displayUnits);
    return n;
  }

  get scenarioImperial() {
    return designStore.currentAsphaltImperial;
  }

  validations() {
    // @ts-ignore
    return createAsphaltValidations(this.scenarioImperial);
  }

  save() {
    this.sync();
    designStore.saveCurrentAsphaltScenario();
  }

  sync() {
    console.log('Saving in design params');
    this.scenario.deltaServiceability = this.deltaServicability;
    designStore.setCurrentAsphaltScenario(this.scenario);
  }


  beforeRouteLeave(to: Route, from: Route, next: Function) {
    this.save();
    next();
  }

  reliabilityOptions: { value: number, text: string }[] = [
    { value: 50, text: '50%' },
    { value: 60, text: '60%' },
    { value: 70, text: '70%' },
    { value: 75, text: '75%' },
    { value: 80, text: '80%' },
    { value: 85, text: '85%' },
    { value: 90, text: '90%' },
    { value: 95, text: '95%' },
    { value: 99, text: '99%' },

  ];

  get zr() {
    const zr = findZr(this.scenario.reliabilityLevel || 50);
    return zr;
  }

  get deltaServicability(): number | null {
    if (this.scenario.terminalServiceability !== null && this.scenario.initialServiceability !== null) {
      return Math.abs(this.scenario.terminalServiceability - this.scenario.initialServiceability);
    }
    return null;
  }
}
